// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { AnalyticsPlugin, AnalyticsPlugin as ApplicationInsights } from "./JavaScriptSDK/AnalyticsPlugin";
//# sourceMappingURL=applicationinsights-analytics-js.js.map